import { core } from '@icc/shared/helpers';
import { IWindowConfiguration } from '../window-configuration';
import { DoorConfiguration } from '../door-configuration';

export function changesInVersion22(
    oldConfiguration: any,
): IWindowConfiguration {
    const configuration: IWindowConfiguration = {
        ...core.copy(oldConfiguration),
    };

    if (configuration.type === 'door') {
        (configuration as DoorConfiguration).components = {
            ...(configuration as DoorConfiguration).components,
            pull: true,
            recessedPull: true
        }
    }

    return configuration;
}


